<!--
 * @FileDescription: 状态小组件
 * @Author: 陈文景
 * @Date: 2022-12-29 15:11:42
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->
<template>
  <div :class="['status', { orange: orange, green: green, purple: purple, brown: brown, blue: blue }]">{{ text }}</div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      required: false,
      default: '-'
    },
    orange: {
      type: Boolean,
      required: false,
      default: false
    },
    green: {
      type: Boolean,
      required: false,
      default: false
    },
    purple: {
      type: Boolean,
      required: false,
      default: false
    },
    brown: {
      type: Boolean,
      required: false,
      default: false
    },
    blue: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.status {
  display: inline-block;
  position: relative;
  height: 36px;
  padding: 0 16px 0 28px;
  line-height: 36px;
  border-radius: 18px;

  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 15px;
    width: 6px;
    height: 6px;
    border-radius: 100%;
    transform: translateY(-50%);
  }
}

.orange {
  color: #f9973c;
  background-color: #fff6ee;
  &::after {
    background-color: #f9973c;
  }
}

.green {
  color: #99c41c;
  background: rgba(153, 196, 28, 0.06);
  &::after {
    background: #99c41c;
  }
}

.purple {
  color: #953ac0;
  background: rgba(149, 58, 192, 0.1);
  &::after {
    background: #953ac0;
  }
}

.brown {
  color: #b15a44;
  background: rgba(179, 97, 71, 0.15);
  &::after {
    background: #b15a44;
  }
}

.blue {
  color: #296ac7;
  background: #e9f2ff;
  &::after {
    background: #296ac7;
  }
}
</style>
